/* global I18n, messg */
import './styles.scss'
import PropTypes from 'prop-types'

import React, { useState, useRef } from 'react'
import Modal from 'react-responsive-modal'
import { useMediaQuery } from 'react-responsive'

import MobileProfilePhoto from './mobile-profile-photo'
import TabletProfilePhoto from './tablet-profile-photo'
import DesktopProfilePhoto from './desktop-profile-photo'
import Webcam from '~/scenes/shared/webcam'

import {
  MAX_SMALL_WIDTH,
  MIN_MEDIUM_WIDTH,
  MAX_MEDIUM_WIDTH,
  MIN_LARGE_WIDTH,
  MB_FACTOR,
  MAX_UPLOAD_PHOTO_SIZE,
  MAX_WIDTH,
  MAX_HEIGHT,
  MAX_IMAGE_RESOLUTION,
  ACCEPTED_EXTENSIONS
} from './constants.js'

const showError = () => messg.error(I18n.t('activerecord.errors.models.user.attributes.avatar_custom.wrong_type'), 4000)

function ProfilePhoto (props) {
  const { setUploadedAvatar, openWebcam, closeWebcam, submit, closeModal, isWebcamOpen, withIconsUi } = props

  const profilePhotoButtonsSectionRef = {
    webcamInputRef: useRef(null),
    uploadImageInputRef: useRef(null)
  }

  const [fileValue, setFileValue] = useState('')

  const isMobileView = useMediaQuery({ maxWidth: MAX_SMALL_WIDTH })
  const isTabletView = useMediaQuery({ minWidth: MIN_MEDIUM_WIDTH, maxWidth: MAX_MEDIUM_WIDTH })
  const isDesktopView = useMediaQuery({ minWidth: MIN_LARGE_WIDTH })

  const handleUploadImage = () => {
    if (profilePhotoButtonsSectionRef.uploadImageInputRef.current) {
      profilePhotoButtonsSectionRef.uploadImageInputRef.current.click()
    }
  }

  const handleWebcam = () => {
    if (withIconsUi) {
      if (isDesktopView) {
        openWebcam()
      } else if (profilePhotoButtonsSectionRef.webcamInputRef && profilePhotoButtonsSectionRef.webcamInputRef.current) {
        profilePhotoButtonsSectionRef.webcamInputRef.current.click()
      }
    } else {
      openWebcam()
    }
  }

  const handleCaptureWebcam = dataUri => {
    setUploadedAvatar(dataUri)
    closeWebcam()
    submit()
  }

  const handleInputWebcamCapture = event => {
    const capturedPhoto = event.target.files[0]

    if (capturedPhoto) {
      const reader = new window.FileReader()

      reader.onload = function () {
        setUploadedAvatar(reader.result)
        submit()
      }

      reader.onabort = showError
      reader.onerror = showError
      reader.readAsDataURL(capturedPhoto)
    }
  }

  const handleChangeUploadImage = event => {
    const uploadedPhoto = event.target.files[0]
    const isPassedSize = uploadedPhoto && uploadedPhoto.size / MB_FACTOR < MAX_UPLOAD_PHOTO_SIZE
    const isPassedExtension = ACCEPTED_EXTENSIONS.includes(uploadedPhoto.type)

    if (!uploadedPhoto || !isPassedSize || !isPassedExtension) {
      showError()
      setFileValue('')
      return
    }

    const previewImage = window.URL.createObjectURL(uploadedPhoto)
    const img = new window.Image()
    img.src = previewImage
    img.onload = function () {
      const width = img.width
      const height = img.height
      const minDimension = width >= MAX_WIDTH && height >= MAX_HEIGHT
      const maxDimension = height * width <= MAX_IMAGE_RESOLUTION
      const isPassedDimensions = minDimension && maxDimension
      if (isPassedDimensions) {
        const reader = new window.FileReader()
        reader.onload = function () {
          setUploadedAvatar(reader.result)
          submit()
        }
        reader.onabort = showError
        reader.onerror = showError
        reader.readAsDataURL(uploadedPhoto)
        window.URL.revokeObjectURL(previewImage)
      } else {
        showError()
        setFileValue('')
        window.URL.revokeObjectURL(previewImage)
      }
    }
    img.onerror = function () {
      showError()
      setFileValue('')
      window.URL.revokeObjectURL(previewImage)
    }
  }

  const { avatars, avatarFormat } = props.avatar
  const avatar = avatarFormat ? avatars[avatarFormat] : ''

  const profilePhotoProps = {
    closeModal,
    fileValue,
    handleChangeUploadImage,
    handleInputWebcamCapture,
    handleUploadImage,
    handleWebcam,
    withIconsUi,
    avatar
  }

  return (
    <>
      {isMobileView && <MobileProfilePhoto ref={profilePhotoButtonsSectionRef} {...profilePhotoProps} />}
      {isTabletView && <TabletProfilePhoto ref={profilePhotoButtonsSectionRef} {...profilePhotoProps} />}
      {isDesktopView && <DesktopProfilePhoto ref={profilePhotoButtonsSectionRef} {...profilePhotoProps} />}
      <Modal
        closeIconSize={18}
        classNames={{
          overlay: 'webcam-modal-overlay',
          modal: 'webcam-modal-modal',
          closeButton: 'close-button'
        }}
        center
        open={isWebcamOpen}
        onClose={closeWebcam}
        showCloseIcon={true}
      >
        <Webcam close={closeWebcam} capture={handleCaptureWebcam} withIconsUi />
      </Modal>
    </>
  )
}

ProfilePhoto.propTypes = {
  setUploadedAvatar: PropTypes.func,
  openWebcam: PropTypes.func,
  closeWebcam: PropTypes.func,
  submit: PropTypes.func,
  closeModal: PropTypes.func,
  uploadedAvatar: PropTypes.string,
  isWebcamOpen: PropTypes.bool,
  withIconsUi: PropTypes.bool,
  avatar: PropTypes.object,
  avatarFormat: PropTypes.string
}

export default ProfilePhoto
